<template>
  <v-container fluid>
    <v-layout wrap>
      <v-row align="center" dense>
        <v-col cols="12">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                small
                v-on="on"
                @click="copyTextToClipboard(link)"
                color="orange"
                >file_copy</v-icon
              >
            </template>
            <span>{{ 'Haga click para copiar' }} </span>
          </v-tooltip>

          <span class="caption"
            >Se generó Link Digiventures: {{ this.link }}</span
          >
        </v-col>
        <v-col>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                x-small
                color="primary lighten-2"
                dark
                @click="sendLink"
                >Enviar Link</v-btn
              >
            </template>
            <span
              >{{
                'Al hacer Click, se enviará un SMS con el link para realizar la firma del Legajo Digital'
              }}
            </span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import { http } from '@/axios';

import { mapMutations } from 'vuex';

export default {
  props: ['info', 'solicitudId'],
  computed: {
    link: function() {
      // extraigo el link del texto
      if (this.info.includes('Link Digiventures')) {
        return this.info.substring(17);
      } else {
        return this.info; // se supone viene el link directamente
      }
    },
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
    ]),
    async copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        console.log('Clipboard no habilitado');
        return;
      }
      navigator.clipboard.writeText(text).then(
        function() {
          console.log('Async: Copying to clipboard was successful!');
        },
        function(err) {
          console.error('Async: Could not copy text: ', err);
        }
      );
    },
    async sendLink() {
      var params = {};
      params.creditoId = this.solicitudId;
      params.link = this.link;

      try {
        await http.post('enviosms/linklegajogueno', JSON.stringify(params));

        this.alertSuccess('Se ha enviado el SMS.');
      } catch (error) {
        // Error
        this.alertError(error);
      }
    },
  },
};
</script>
